module.exports = __webpack_public_path__ + "static/media/camera360.ca36881a.svg";